import Tooltip from "@pathwright/ux/src/components/tooltip/Tooltip"
import moment from "moment"
import { TreeNode } from "../../state/tree/path-tree"
import { timeago } from "../../utils"

// TODO: add tooltips here to show full due/completion times
const When = ({ item }: { item: TreeNode<"completion"> }) => {
  const {
    data: {
      completion: { completion_date },
      due
    }
  } = item

  // we still need to show the badge for incomplete but late items
  if (!completion_date && !due) return null

  // tooltip should show full date/time
  const timeFormat = "MMM D, YYYY h:mm A"
  const completionTooltip = completion_date
    ? moment(completion_date).format(timeFormat)
    : null

  return completion_date ? (
    <Tooltip title={completionTooltip} portal={false} fitContent>
      <span>{timeago(completion_date)}</span>
    </Tooltip>
  ) : null
}

export default When
